export default "__VITE_ASSET__0JgoRngS__"